import { render, staticRenderFns } from "./SadakaListReport.vue?vue&type=template&id=967cbe92&"
import script from "./SadakaListReport.vue?vue&type=script&lang=js&"
export * from "./SadakaListReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports